import { TamanhosCartaz } from '@/components/atoms/Cartaz';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $tamanhoCartaz: TamanhosCartaz }>`
  display: grid;

  ${({ theme, $tamanhoCartaz }) => {
    return css`
      grid-template-columns: repeat(
        auto-fill,
        minmax(${theme.tamanhoCartaz.width[$tamanhoCartaz]}px, 1fr)
      );
      gap: ${theme.spacing[6]}px;
    `;
  }};
`;

// export const Container = styled.div`
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;

//   ${({ theme }) => {
//     return css`
//       gap: ${theme.spacing[5]}px;
//     `;
//   }};
// `;
